import React, { Component } from "react";
import axios from "axios";
import Helping from "../../helpers/Helping";
import Service from "../../helpers/service";
import Notification from "../layout/Notification";
import { addCurrentRoute } from '../../actions/profile_action';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import { trackPromise } from "react-promise-tracker";

const { NOT_FOUND } = MESSAGE;
class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_COLLECTION_API + "collection",
            collection: [],
            items: [],
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false,
            total: 0,
            limit: 10,
            search: '',
            sorting: 'id',
            sort_type: 'DESC',
            sort_class: 'fa fa-sort-up'
        };
    }

    componentDidMount() {
        var self = this;

        if (this.props.match.params.id) {
            self.getById(this.props.match.params.id);
            this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    getById = (id) => {
        var $this = this;

        trackPromise(
            axios
                .get(this.state.url + `/${id}`, Helping.getConfig()).then(response => {

                    let { payload } = response.data;
                    this.getCollectionItemsInfo(payload.items);

                    $this.setState({
                        collection: payload,
                        isLoading: false
                    });
                })
                .catch(error => {
                    console.log("error while getting data from id: ", error);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        $this.setState({
                            error_message: error.response.data.message,
                            error_type: "danger",
                            isLoading: false
                        });
                    }
                })
        )
    }

    getCollectionItemsInfo = (collection) => {
        const items_ids = collection.map(col => { return Number(col.item_id) }, []);
        const url = API_URL.ITEM_URL + 'items-by-ids?ids=' + JSON.stringify(items_ids);

        trackPromise(
            Service.getCall(url)
                .then(response => {
                    let { payload } = response.data;

                    this.setState({
                        items: payload.items
                    });
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        this.setState({
                            error_message: error.response.data.message,
                            error_type: "danger",
                            isLoading: false
                        });
                    }
                })
        )
    }

    render() {
        let collection = this.state.collection, items = this.state.items,
            obj = collection.reward ? JSON.parse(collection.reward.content) : {},
            brand = collection.brand_content ? JSON.parse(collection.brand_content) : {};

        return (
            < div class="content user-view" >
                <div class="top-header">
                    <div class="header-title">
                        <h2 class="title">{collection.name}</h2>
                        <span class="title-caption">{collection.type}</span>
                    </div>
                    <div class="header-btn">
                        <Link to={"/collections"} class="custom-btn dark-btn icon-btn md-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                    <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                        <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                        <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                    </g>
                                </g>
                            </svg>
                            <span class="txt-btn">Back</span>
                        </Link>
                        {/* <button class="custom-btn icon-btn dark-btn md-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="15.5" viewBox="0 0 15.5 15.5">
                                <g id="report" transform="translate(0.75 0.75)">
                                    <path id="Path_344" data-name="Path 344" d="M4.75,14.75v1.5a2.949,2.949,0,0,0,2.9,3h8.207a2.949,2.949,0,0,0,2.9-3v-1.5" transform="translate(-4.75 -5.25)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                    <path id="Path_345" data-name="Path 345" d="M12,14.25V4.75" transform="translate(-5 -4.75)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                    <path id="Path_346" data-name="Path 346" d="M8.75,10.75,12,14.25l3.25-3.5" transform="translate(-5 -5.023)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                </g>
                            </svg>
                            <span class="txt-btn">Export</span>
                        </button> */}
                    </div>
                </div>

                <div class="main-content view-page-content">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }

                    <div class="view-tabs multiple-tabs">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#collectionDetail" role="tab">
                                    <svg id="info" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                        <path id="Path_394" data-name="Path 394" d="M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,1.8A7.2,7.2,0,1,1,3.8,11,7.2,7.2,0,0,1,11,3.8Z" transform="translate(-2 -2)" />
                                        <g id="info-2" data-name="info" transform="translate(-444 -18)">
                                            <rect id="Rectangle_277" data-name="Rectangle 277" width="1.5" height="6" rx="0.75" transform="translate(452.5 25)" />
                                            <rect id="Rectangle_278" data-name="Rectangle 278" width="1.5" height="1.5" rx="0.75" transform="translate(452.5 22.5)" />
                                        </g>
                                    </svg>
                                    <span class="tab-text">Detail Collection</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#brandDetail" role="tab">
                                    <svg id="brand" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                        <path id="Path_396" data-name="Path 396" d="M17.2,8.788,9.009.567A2.614,2.614,0,0,0,6.861-.191L2.826.188A2.7,2.7,0,0,0,.419,2.6l-.4,4.028A2.61,2.61,0,0,0,.773,8.788L9.009,17.01a2.688,2.688,0,0,0,1.911.782h0a2.73,2.73,0,0,0,1.911-.782l4.389-4.43A2.71,2.71,0,0,0,18,10.66,2.813,2.813,0,0,0,17.2,8.788Zm-.59,1.919a1.311,1.311,0,0,1-.378.924l-4.389,4.407a1.321,1.321,0,0,1-.92.4,1.23,1.23,0,0,1-.92-.4L1.788,7.817a1.443,1.443,0,0,1-.4-.924V6.751l.4-4.028a1.333,1.333,0,0,1,1.18-1.185l4.012-.4h.141a1.3,1.3,0,0,1,.92.379l8.212,8.221A1.634,1.634,0,0,1,16.607,10.708Z" transform="translate(0 0.209)" />
                                        <path id="Path_397" data-name="Path 397" d="M22.727,19.9h0A2.309,2.309,0,0,0,20.42,22.19a2.377,2.377,0,0,0,.666,1.648,2.282,2.282,0,0,0,1.641.693,2.357,2.357,0,0,0,1.641-.669,2.3,2.3,0,0,0,.69-1.648,2.26,2.26,0,0,0-.69-1.648A2.468,2.468,0,0,0,22.727,19.9Zm.9,2.317a1.028,1.028,0,0,1-.262.669.933.933,0,0,1-.666.263.947.947,0,0,1-.928-.931,1.029,1.029,0,0,1,.262-.669.962.962,0,0,1,.642-.263,1.07,1.07,0,0,1,.666.263A.987.987,0,0,1,23.631,22.214Z" transform="translate(-16.755 -16.288)" />
                                    </svg>
                                    <span class="tab-text">Brand</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#rewardDetail" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.2" height="18.2" viewBox="0 0 18.2 18.2">
                                        <g id="reward" transform="translate(0.1 0.1)">
                                            <path id="Path_395" data-name="Path 395" d="M17.357,1.385H14.143V.692A.632.632,0,0,0,13.5,0h-9a.632.632,0,0,0-.643.692v.692H.643A.632.632,0,0,0,0,2.077V3.946A5.6,5.6,0,0,0,5.014,9.692a5.038,5.038,0,0,0,2.057,1.661v1.8H6.429A1.971,1.971,0,0,0,4.5,15.231v2.077A.632.632,0,0,0,5.143,18h7.714a.632.632,0,0,0,.643-.692V15.231a1.971,1.971,0,0,0-1.929-2.077h-.642v-1.8a5.038,5.038,0,0,0,2.057-1.661A5.646,5.646,0,0,0,18,3.946V2.077A.632.632,0,0,0,17.357,1.385ZM1.286,3.946V2.769H3.857V6.231A5.645,5.645,0,0,0,4.179,8.1,4.287,4.287,0,0,1,1.286,3.946ZM12.214,15.231v1.384H5.786V15.231a.632.632,0,0,1,.643-.692h5.142A.632.632,0,0,1,12.214,15.231Zm-2.121-5.054a.684.684,0,0,0-.45.692v2.285H8.357V10.869a.834.834,0,0,0-.45-.692A4.094,4.094,0,0,1,5.914,8.654L5.85,8.585a4.424,4.424,0,0,1-.707-2.423V1.385h7.714V6.231a4.422,4.422,0,0,1-.707,2.423l-.064.069A3.965,3.965,0,0,1,10.093,10.177Zm6.621-6.231A4.287,4.287,0,0,1,13.821,8.1a5.645,5.645,0,0,0,.322-1.869V2.769h2.571Z" stroke-width="0.2" />
                                        </g>
                                    </svg>
                                    <span class="tab-text">Reward</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#badgeDetail" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18.537" height="18.502" viewBox="0 0 18.537 18.502">
                                        <g id="badge" transform="translate(0.286 0.25)">
                                            <path id="Path_398" data-name="Path 398" d="M9,0A6.59,6.59,0,0,0,3.5,10.225L.071,15.168a.4.4,0,0,0,.413.619l2.631-.525.7,2.444a.4.4,0,0,0,.725.106L7.588,13.05a6.724,6.724,0,0,0,2.824,0l3.049,4.762a.4.4,0,0,0,.725-.106l.7-2.444,2.631.525a.4.4,0,0,0,.412-.619L14.5,10.225A6.589,6.589,0,0,0,9,0ZM9,.8A5.8,5.8,0,1,1,3.2,6.6,5.793,5.793,0,0,1,9,.8ZM8.963,2.806a.4.4,0,0,0-.319.219L7.682,4.944,5.545,5.25a.4.4,0,0,0-.225.675l1.55,1.494L6.5,9.531a.4.4,0,0,0,.328.459l.022,0a.405.405,0,0,0,.237-.044L9,8.95l1.912,1a.4.4,0,0,0,.545-.161.4.4,0,0,0,.042-.258l-.369-2.112,1.55-1.494a.4.4,0,0,0,0-.563.4.4,0,0,0-.225-.112l-2.137-.306L9.356,3.025A.4.4,0,0,0,8.963,2.806ZM9,4.094l.687,1.381a.4.4,0,0,0,.306.219l1.543.225L10.418,6.994a.4.4,0,0,0-.119.356l.269,1.519L9.187,8.15a.405.405,0,0,0-.375,0l-1.375.719L7.694,7.35a.4.4,0,0,0-.119-.356L6.463,5.919l1.543-.225a.4.4,0,0,0,.306-.219ZM4,10.9a6.619,6.619,0,0,0,2.781,1.919L4.345,16.631l-.556-1.944a.4.4,0,0,0-.469-.281L1.3,14.812Zm10,0L16.7,14.812l-2.024-.406a.4.4,0,0,0-.469.281l-.556,1.944-2.437-3.812A6.618,6.618,0,0,0,14,10.9Z" stroke-width="0.5" />
                                        </g>
                                    </svg>
                                    <span class="tab-text">Badge</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#itemDetail" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                                        <path id="items" d="M17.589,3.849a6.218,6.218,0,0,1,0,9.016l-3.363,3.214-.678.683-1.976,1.905a4.833,4.833,0,0,1-6.666,0,4.462,4.462,0,0,1,0-6.457l.649-.625.679-.654,4.512-4.351a3.224,3.224,0,0,1,2.094-.91,2.8,2.8,0,0,1,2.064.768,2.737,2.737,0,0,1-.147,3.982L9.566,15.424a.959.959,0,0,1-1.327,0,.878.878,0,0,1,0-1.28L13.43,9.139a.994.994,0,0,0,.147-1.422,1.086,1.086,0,0,0-1.475.142L7.561,12.21l-.679.654-.648.654a2.636,2.636,0,0,0,0,3.839,2.914,2.914,0,0,0,4.011,0l2.006-1.934L12.9,14.8l3.333-3.214a4.46,4.46,0,0,0,0-6.457,4.834,4.834,0,0,0-6.665,0L7.561,7.062a.959.959,0,0,1-1.327,0,.878.878,0,0,1,0-1.28L8.239,3.849A6.667,6.667,0,0,1,12.9,2,6.738,6.738,0,0,1,17.589,3.849Z" transform="translate(-3.524 -2)" />
                                    </svg>
                                    <span class="tab-text">Items</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#collectionImages" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                        <path id="images" d="M5.6,2A3.6,3.6,0,0,0,2,5.6V16.4A3.6,3.6,0,0,0,5.6,20H16.4A3.6,3.6,0,0,0,20,16.4V5.6A3.6,3.6,0,0,0,16.4,2Zm0,1.8H16.4a1.8,1.8,0,0,1,1.8,1.8v7.863A3.728,3.728,0,0,0,15.5,11.9c-1.164,0-2.2.829-3.207,2.165-.049.065-.064.106-.112.172-.212-.62-.447-1.218-.7-1.8C10.354,9.863,9.088,8.3,7.4,8.3c-1.469,0-2.627,1.242-3.592,3.1L3.8,5.6A1.8,1.8,0,0,1,5.6,3.8Zm1.8,6.3c.674,0,1.6,1.137,2.447,3.065a23.551,23.551,0,0,1,.871,2.39c.09.286.3,1.02.31,1.069a.906.906,0,0,0,1.688.169c.049-.1.144-.272.282-.507a12.184,12.184,0,0,1,.759-1.153c.685-.913,1.333-1.435,1.744-1.435s1.059.521,1.743,1.435a12.635,12.635,0,0,1,.939,1.474A1.781,1.781,0,0,1,16.4,18.2H5.6a1.746,1.746,0,0,1-1.265-.535,1.786,1.786,0,0,1-.507-1.21c.057-.2.178-.66.253-.9a23.772,23.772,0,0,1,.872-2.39C5.8,11.237,6.726,10.1,7.4,10.1Zm6.3-2.7a.9.9,0,1,1,.9.9A.9.9,0,0,1,13.7,7.4Z" transform="translate(-2 -2)" />
                                    </svg>
                                    <span class="tab-text">Images</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content collection-view">
                        <div class="tab-pane active" id="collectionDetail" role="tabpanel">
                            <div class="row">
                                <div class="col-sm-6 col-md-6 col-lg-4">
                                    <ul class="list-view">
                                        <li>
                                            <label for="">Collection ID</label>
                                            <span>{collection.id}</span>
                                        </li>
                                        <li>
                                            <label for="">Title</label>
                                            <span>{collection.name}</span>
                                        </li>
                                        <li>
                                            <label for="">Code</label>
                                            <span>{collection.code}</span>
                                        </li>
                                        <li>
                                            <label for="">Type</label>
                                            <span>{collection.type}</span>
                                        </li>
                                        <li>
                                            <label for="">List Order</label>
                                            <span>{collection.list_order ? collection.list_order : 0}</span>
                                        </li>
                                        <li>
                                            <label for="">Expire At</label>
                                            <span>{collection.expire_at ? Helping.convertTimeToHumanReadableFormat(collection.expire_at) : 'None'}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-5">
                                    <ul class="list-view">
                                        <li>
                                            <label for="">Total Rewards</label>
                                            <span>{collection.total_rewards}</span>
                                        </li>
                                        <li>
                                            <label for="">Remaining Rewards</label>
                                            <span>{collection.remaining}</span>
                                        </li>
                                        <li>
                                            <label for="">Active</label>
                                            <span>{collection.is_active ? "True" : "False"}</span>
                                        </li>
                                        <li>
                                            <label for="">Archive</label>
                                            <span>{collection.is_archive ? "True" : "False"}</span>
                                        </li>
                                        <li>
                                            <label for="">Awarables</label>
                                            <span>{collection.is_awardable ? "True" : "False"}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <ul class="list-view">
                                        <li>
                                            <label for="">Description</label>
                                            <span>{collection.description}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="brandDetail" role="tabpanel">
                            <div class="listing-tbl table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">ID</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Logo</th>
                                            <th scope="col">Dark Logo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key={collection.brand_id}>
                                            <td scope="row">{collection.brand_id}</td>
                                            <td>{brand ? brand.name : null}</td>
                                            <td>
                                                <div class="logoImg">
                                                    <img src={brand ? brand.logo : null} alt="" class="img-fluid" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="logoImg">
                                                    <img src={brand ? brand.dark_logo : null} alt="" class="img-fluid" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="tab-pane" id="rewardDetail" role="tabpanel">
                            <div class="listing-tbl table-responsive">
                                {collection.reward ? (
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Thumbnail</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Code</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td scope="row">{collection.reward ? collection.reward.id : null}</td>
                                                <td>
                                                    <div class="logoImg">
                                                        <img src={obj.thumbnail_url ? obj.thumbnail_url : null} alt="" class="img-fluid" />
                                                    </div>
                                                </td>
                                                <td>{obj.name ? obj.name : null}</td>
                                                <td>{collection.reward.code ? collection.reward.code : null}</td>
                                                <td>{collection.reward.type ? collection.reward.type : null}</td>
                                                <td>{Helping.convertTimeToHumanReadableFormat(collection.reward.created_at)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ) : (
                                    <Notification
                                        type="danger"
                                        message={Helping.getMessageString(NOT_FOUND, "Items")}
                                        callback={this.removeNetworkError}
                                    />
                                )}
                            </div>
                        </div>

                        <div class="tab-pane" id="badgeDetail" role="tabpanel">
                            <div class="listing-tbl table-responsive">
                                {collection.badge ? (
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Logo</th>
                                                <th scope="col">Gray Logo</th>
                                                <th scope="col">Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td scope="row">{collection.badge.id}</td>
                                                <td>{collection.badge.name}</td>
                                                <td>
                                                    <div class="logoImg">
                                                        <img src={collection.badge.logo} alt="Badge Logo" class="img-fluid" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="logoImg">
                                                        <img src={collection.badge.grey_logo} alt="Badge Grey Logo" class="img-fluid" />
                                                    </div>
                                                </td>
                                                <td>{Helping.convertTimeToHumanReadableFormat(collection.badge.created_at)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ) : (
                                    <Notification
                                        type="danger"
                                        message={Helping.getMessageString(NOT_FOUND, "Badge")}
                                        callback={this.removeNetworkError}
                                    />
                                )}
                            </div>
                        </div>

                        <div class="tab-pane" id="itemDetail" role="tabpanel">
                            <div class="listing-tbl table-responsive">
                                {items.length > 0 ? (
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Thumbnail</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Code</th>
                                                <th scope="col">Brand</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((item, i) => (
                                                <tr key={i}>
                                                    <td scope="row">{item.id}</td>
                                                    <td>
                                                        <div class="logoImg">
                                                            <img src={item.thumbnail_url ? item.thumbnail_url : null} alt="" class="img-fluid" />
                                                        </div>
                                                    </td>
                                                    <td>{item.name ? item.name : null}</td>
                                                    <td>{item.code ? item.code : null}</td>
                                                    <td>{item.brand ? item.brand.name : null}</td>
                                                </tr>
                                            )
                                            )}
                                        </tbody>
                                    </table>
                                ) : (
                                    <Notification
                                        type="danger"
                                        message={Helping.getMessageString(NOT_FOUND, "Items")}
                                        callback={this.removeNetworkError}
                                    />
                                )}
                            </div>
                        </div>

                        <div class="tab-pane collectionImg" id="collectionImages" role="tabpanel">
                            <div class="row">
                                <div class="column col-md-6">
                                    <div class="colFeatureImg">
                                        <label for="">Landscape</label>
                                        <span class="featureImg img">
                                            <img src={collection.landscape_thumbnail_url ? collection.landscape_thumbnail_url : null} alt="Landscape" class="img-fluid" />
                                        </span>
                                        <a className="link" target="_blank" href={collection.landscape_thumbnail_url ? collection.landscape_thumbnail_url : null}>{collection.landscape_thumbnail_url ? collection.landscape_thumbnail_url : null}</a>
                                    </div>
                                </div>
                                <div class="column col-md-6">
                                    <div class="colFeatureImg">
                                        <label for="">Banner</label>
                                        <span class="featureImg img">
                                            <img src={collection.banner_url ? collection.banner_url : null} alt="Banner" class="img-fluid" />
                                        </span>
                                        <a className="link" target="_blank" href={collection.banner_url ? collection.banner_url : null}>{collection.banner_url ? collection.banner_url : null}</a>
                                    </div>
                                </div>
                                <div class="column col-md-6">
                                    <div class="colFeatureImg">
                                        <label for="">Portrait</label>
                                        <span class="featureImg img">
                                            <img src={collection.portrait_thumbnail_url ? collection.portrait_thumbnail_url : null} alt="Potrait" class="img-fluid" />
                                        </span>
                                        <a className="link" target="_blank" href={collection.portrait_thumbnail_url ? collection.portrait_thumbnail_url : null}>{collection.portrait_thumbnail_url ? collection.portrait_thumbnail_url : null}</a>
                                    </div>
                                </div>
                                <div class="column col-md-6">
                                    <div class="colFeatureImg">
                                        <label for="">Featured Banner</label>
                                        <span class="featureImg img">
                                            <img src={collection.featured_banner_url ? collection.featured_banner_url : null} alt="Featured Banner" class="img-fluid" />
                                        </span>
                                        <a className="link" target="_blank" href={collection.featured_banner_url ? collection.featured_banner_url : null}>{collection.featured_banner_url ? collection.featured_banner_url : null}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
